module.exports = __webpack_public_path__ + "static/media/cloudRiches_logo_white.f15a9ef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cloudRiches_logo_white.png
// module id = 453
// module chunks = 0